import { useEffect, useState } from 'react';
import { getPublicConfig, type PublicConfig } from './api';

// Fase 27B: hook compartido para leer las capacidades públicas (¿ofrecer registro autoservicio?). Lo usan
// tanto el login del tenant (CTA "Crear cuenta") como el shell de signup. Ante error de red asume que nada
// está habilitado (fail-closed): nunca ofrecer un flujo que el backend rechazaría.
export interface PublicConfigState { config: PublicConfig | null; loading: boolean }

export function usePublicConfig(): PublicConfigState {
  const [config, setConfig] = useState<PublicConfig | null>(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let alive = true;
    getPublicConfig()
      .then((c) => { if (alive) setConfig(c); })
      .catch(() => { if (alive) setConfig({ signupEnabled: false, emailDeliveryAvailable: false, support: { email: null, whatsapp: null } }); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, []);
  return { config, loading };
}
